import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { membersKeys } from "@/features/members/queries/membersQueryKeys";
import membersService from "@/features/members/services/membersService";

/**
 * Mutation hook for updating a member's display name
 * Invalidates member detail and list queries on success
 */
export function useUpdateMemberDisplayName(uid: string) {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (displayName: string) => {
            await membersService.updateMemberDisplayName(uid, displayName);
        },
        onError: (error) => {
            const errorMessage = error instanceof Error ? error.message : "Failed to update name. Please try again.";
            toast.error(errorMessage);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: membersKeys.detail(uid),
            });
            queryClient.invalidateQueries({
                queryKey: membersKeys.all,
            });
        },
    });

    return {
        error: mutation.error,
        isError: mutation.isError,
        isPending: mutation.isPending,
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
    };
}
